/**
 * Uploads a file to Azure Blob Storage through a write SAS link from
 * `fetchUploadLink`. `x-ms-blob-type` is what Azure's Put Blob operation
 * requires. No JSON travels in either direction, so nothing is validated.
 *
 * @param file - The file to upload.
 * @param sasLink - The write SAS link for the target blob.
 * @throws Error when the storage answers outside the 2xx range.
 */
export async function uploadFileToBlobStorage(file: File, sasLink: string) {
  const response = await fetch(sasLink, {
    body: file,
    headers: {
      'Content-Type': file.type || 'application/octet-stream',
      'x-ms-blob-type': 'BlockBlob',
    },
    method: 'PUT',
  });

  if (!response.ok) {
    throw new Error(`Failed to upload file: ${response.status}`);
  }
}
